import { createApp, nextTick } from "vue";
import App from "./App.vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/assets/custom.scss";

const app = createApp(App);

import "@/plugins/vue-fontawesome";
app.component("icon", FontAwesomeIcon);

// favicon
const favicon =
  document.querySelector("link[rel~='icon']") || document.createElement("link");
favicon.rel = "icon";
favicon.href = `/favicon_${process.env.VUE_APP_CLIENT}.ico`;
document.head.appendChild(favicon);

// vou-debounce
import { vue3Debounce } from "vue-debounce";
app.directive("debounce", vue3Debounce({ lock: true }));

// vue-toastification
import Toast, { useToast, POSITION, TYPE } from "@brackets/vue-toastification";
import "@brackets/vue-toastification/dist/index.css";

const options = { position: POSITION.BOTTOM_RIGHT };
app.use(Toast, options);
app.config.globalProperties.$toast = useToast();

// filters
import { DateTime } from "luxon";
app.config.globalProperties.$filters = {
  formatDate(d) {
    if (!d) return "";
    let dt = DateTime.fromJSDate(new Date(d)).setLocale("de");
    return dt.toFormat("dd.MM.yyyy");
  },
  formatDateTime(d) {
    if (!d) return "";
    let dt = DateTime.fromJSDate(new Date(d)).setLocale("de");
    return dt.toFormat("dd.MM.yyyy HH:mm");
  },
  formatCurrency(value) {
    const formatter = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    });
    return formatter.format(value);
  },
};

// api
import axiosInstance from "@/axiosInstance";
app.config.globalProperties.$api = axiosInstance;
app.config.productionTip = false;

import messageMixin from "@/mixins/MessagesMixin";
app.mixin(messageMixin);

import VTooltip from "v-tooltip";
import "@/assets/tooltip.css";
app.use(VTooltip);

import money from "v-money3";
app.use(money);

import Vue3ConfirmDialog from "vue3-confirm-dialog";
import "vue3-confirm-dialog/style";
app.use(Vue3ConfirmDialog);
app.component("vue3-confirm-dialog", Vue3ConfirmDialog.default);

import router from "./router";
app.use(router);

import store from "./store";
app.use(store);

app.mount("#app");

nextTick(() => {
  const reason = sessionStorage.getItem("logoutReason");
  if (!reason) return;
  sessionStorage.removeItem("logoutReason");

  const texts = {
    expired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    logout: "Sie wurden abgemeldet.",
  };
  if (texts[reason]) useToast()(texts[reason], { type: TYPE.WARNING });
});
